module.exports = new __parcel__URL__("vr-reparent-onboarding-light.9e71c36b.svg").toString();